import { Label } from "../base/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../base/select";

const SORT_BY_OPTIONS = [
  {
    value: "relevance_desc",
    label: "Relevance",
  },
  {
    value: "price_asc",
    label: "Price: Low to High",
  },
  {
    value: "price_desc",
    label: "Price: High to Low",
  },
] as const;

type ProductSortByValue = (typeof SORT_BY_OPTIONS)[number]["value"];

export type ProductSortByProps = {
  value: ProductSortByValue;
  onChange: (value: ProductSortByValue) => void;
};

export function ProductSortBy(props: ProductSortByProps) {
  const { value, onChange } = props;
  return (
    <>
      <Label className="whitespace-nowrap">Sort by:</Label>
      <Select
        value={value}
        onValueChange={(nextSortBy) =>
          onChange(nextSortBy as ProductSortByValue)
        }
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          {SORT_BY_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
}
